import { componentsFromGlobRecord, directivesFromGlobRecord, pagesFromGlobRecord, translationFromGlobRecord } from './utils/platformBuilder'

/**
 * Base app with sync components
 */
export default {
  name: 'base',
  pages: pagesFromGlobRecord(
    import.meta.glob('./pages/**/*.vue', { eager: true }),
    './pages'
  ),
  components: componentsFromGlobRecord(
    import.meta.glob('./components/**/*.vue', { eager: true })
  ),
  directives: directivesFromGlobRecord(
    import.meta.glob('./directives/**/*.js', { eager: true })
  ),
  translations: translationFromGlobRecord(
    import.meta.glob('./translations/**/*.yml', { eager: true })
  ),
}
